import { useMemo } from 'react';
import { cx } from '@emotion/css';
import { CaretDownOutlined, ReloadOutlined } from '@ant-design/icons';
import { TimeSortType } from 'hooks/business/conversationsHooks/useCategoryFilterState';
import { useTranslate } from '@tolgee/react';
import { Dropdown, Menu } from 'antd';
import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';
import { useCategoryAwareFilterAdvance } from 'hooks/business/conversationsHooks/useCategoryFilterState';
import { ConversationCategoryType } from 'hooks/business/conversationsHooks/useConversationCategory';

export interface TimeSortProps {
  category: ConversationCategoryType;
  type: TimeSortType;
  onChange: (type: TimeSortType) => void;
  onRefresh: () => void;
}

export const TimeSort = (props: TimeSortProps) => {
  const { category, type, onChange, onRefresh } = props;
  const { t } = useTranslate();

  const { whiteListConfig: { CONVERSATION_SORT_BY_WAIT_TIME = false } = {} } =
    useOrgConfigStateValue();

  const filter = useCategoryAwareFilterAdvance(category);

  const typeLabelMap = useMemo(() => {
    return {
      asc: t('convList.ascendText'),
      desc: t('convList.descendText'),
      ...(!CONVERSATION_SORT_BY_WAIT_TIME || filter?.statusFilters?.includes('IN_RECEPTION')
        ? {}
        : {
            waitDesc: t('买家等待时间从长到短'),
            waitAsc: t('买家等待时间从短到长'),
          }),
    };
  }, [t, CONVERSATION_SORT_BY_WAIT_TIME, filter?.statusFilters]);

  return (
    <div className="flex justify-between p-2">
      <div
        className={cx(
          'flex items-center gap-[2px] text text-xs text-content-200 cursor-pointer hover:text-primary-hover',
        )}
        onClick={onRefresh}
      >
        <span>{t('convList.refresh')}</span>
        <ReloadOutlined />
      </div>
      <Dropdown
        overlay={
          <Menu activeKey={type} onClick={({ key }) => onChange?.(key as any)}>
            {Object.entries(typeLabelMap).map(([type, label]) => {
              return <Menu.Item key={type}>{label}</Menu.Item>;
            })}
          </Menu>
        }
      >
        <div className="flex items-center gap-[2px] text text-xs text-content-200 cursor-pointer hover:text-primary-hover">
          {typeLabelMap[type]}
          <CaretDownOutlined />
        </div>
      </Dropdown>
    </div>
  );
};
